import React from "react";
import { Scrollbars } from 'react-custom-scrollbars';
import { disableSelectStyle, disableSelectStyleReset } from 'react-custom-scrollbars/lib/Scrollbars/styles';
import returnFalse from 'react-custom-scrollbars/lib/utils/returnFalse';
import css from 'dom-css';

export default class CustomScrollbars extends Scrollbars {


    setupDragging() {
        css((this.props.document || document).body, disableSelectStyle);
        (this.props.document || document).addEventListener('mousemove', this.handleDrag);
        (this.props.document || document).addEventListener('mouseup', this.handleDragEnd);
        (this.props.document || document).onselectstart = returnFalse;
    }

    teardownDragging() {

        css((this.props.document || document).body, disableSelectStyleReset);
        (this.props.document || document).removeEventListener('mousemove', this.handleDrag);
        (this.props.document || document).removeEventListener('mouseup', this.handleDragEnd);
        (this.props.document || document).onselectstart = undefined;
    }
}